"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleName = exports.AnalyticsErrorTypes = void 0;
var AnalyticsErrorTypes;
(function (AnalyticsErrorTypes) {
    AnalyticsErrorTypes["inline"] = "Inline";
    AnalyticsErrorTypes["api"] = "api";
    AnalyticsErrorTypes["connectivity"] = "Connectivity";
    AnalyticsErrorTypes["SAP"] = "SAP";
    AnalyticsErrorTypes["errorPage"] = "Error Page";
})(AnalyticsErrorTypes = exports.AnalyticsErrorTypes || (exports.AnalyticsErrorTypes = {}));
exports.consoleName = 'Shared Tealium Service';
